module.exports = __webpack_public_path__ + "static/img/ydd-sph.b1272f36.png";